export default {
  Auth: {
    region: 'us-west-2',
    identityPoolId: 'us-west-2:2ed6fd1f-4152-4bea-86a8-aad1647c43c0',
    userPoolId: 'us-west-2_xvXXLkujb',
    userPoolWebClientId: '7lpvpj5jcfsiq33n760aiv8rho',
  },
  API: {
    endpoints: [
      {
        name: 'ScoringData',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-mobileData/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'AllLoans',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-mobileAllLoans/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'SingleLoan',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-mobileSingleLoan/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'InviteReference',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-getReferenceFromInvite/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'ExpireMobileInvite',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-expireMobileInvite/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'RunIntegration',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-integrations-uat-runIntegration/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'SkipBanking',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-mobileSkipBanking/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'GetTrustStartPublicConfigWithCreds',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-getTrustStartPublicConfigWithCreds/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'SmartConsentPrefill',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-uat-prefill/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'SmartConsentLeads',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-uat-leads/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'SmartConsentOffers',
        endpoint: 'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-uat-offers/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'StoreBankingEvents',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-uat-storeBankingEvents/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'TrustStartDealerIbvRequest',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-trustStartDealerIbvRequest/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'TrustStartFindScoringRequest',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-trustStartFindScoringRequest/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'TrustStartStatus',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-scoring-api-uat-trustStartStatus/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'ChatAPI',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-chat-dev-httpChat/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'Auth',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-uat-auth/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'DataProviderList',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-uat-dataProviderList/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'Consent',
        endpoint:
          'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/ts-smartconsent-uat-consent/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
      {
        name: 'GetTerms',
        endpoint:
            'https://lambda.us-west-2.amazonaws.com/2015-03-31/functions/clientconsole-uat-getTerms/invocations',
        service: 'lambda',
        region: 'us-west-2',
      },
    ],
  },
  AppSync: {
    url: 'https://p3hpksqxhfd75lldrtu27utyxu.appsync-api.us-west-2.amazonaws.com/graphql',
    region: 'us-west-2',
    auth: {
      type: 'AWS_IAM',
    },
  },
  aws_appsync_graphqlEndpoint: 'https://p3hpksqxhfd75lldrtu27utyxu.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AWS_IAM',
};
